import React from "react";

const NotFound = () => {
  return (
    <div style={{ height: "120vh", background: "url(./assets/37.jpg)" }}>
      Not found
    </div>
  );
};

export default NotFound;
